import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { SearchAncillaryAssetsRequest } from "./ancillary-requests-responses/SearchAncillaryAssetsRequest";
import { SearchAncillaryAssetsResponse } from "./ancillary-requests-responses/SearchAncillaryAssetsResponse";
import { SearchAssetsContentAggregationsRequest } from "./content-requests-reposnses/SearchAssetsContentAggregationsRequest";
import { SearchAssetsContentAggregationsResponse } from "./content-requests-reposnses/SearchAssetsContentAggregationsResponse";
import { SearchMoviesAssetsRequest } from "./movie-requests-responses/SearchMoviesAssetsRequest";
import { SearchMoviesAssetsResponse } from "./movie-requests-responses/SearchMoviesAssetsResponse";
import { AssetStatusesResponse } from "./statuses/AssetStatusesResponse";
import { SearchTvSeriesAssetsRequest } from "./tv-series-requests-responses/SearchTvSeriesAssetsRequest";
import { SearchTvSeriesAssetsResponse } from "./tv-series-requests-responses/SearchTvSeriesAssetsResponse";

export const useSearchMasterApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet } = useAuthorizedFetch();
    const baseUrl = appConfigContext.masterConfig.apiUrl;

    const searchMovies = async (request: SearchMoviesAssetsRequest): Promise<SearchMoviesAssetsResponse> => {
        return httpGet<SearchMoviesAssetsResponse>(`${baseUrl}/search/movies`, request);
    };

    const searchTvSeries = async (request: SearchTvSeriesAssetsRequest): Promise<SearchTvSeriesAssetsResponse> => {
        return httpGet<SearchTvSeriesAssetsResponse>(`${baseUrl}/search/tv-series`, request);
    };

    const searchAncillary = async (request: SearchAncillaryAssetsRequest): Promise<SearchAncillaryAssetsResponse> => {
        return httpGet<SearchAncillaryAssetsResponse>(`${baseUrl}/search/ancillaries`, request);
    };

    const getAssetStatuses = async (): Promise<AssetStatusesResponse> => {
        return httpGet<AssetStatusesResponse>(`${baseUrl}/search/statuses`);
    };

    const searchAssetsContentAggregations = async (
        request: SearchAssetsContentAggregationsRequest
    ): Promise<SearchAssetsContentAggregationsResponse> => {
        return httpGet<SearchAssetsContentAggregationsResponse>(
            `${baseUrl}/search/search-content-aggregations`,
            request
        );
    };

    return {
        searchMovies,
        searchTvSeries,
        getAssetStatuses,
        searchAncillary,
        searchAssetsContentAggregations
    };
};
